__turbopack_context__.v({
  "collapsible": "CoreCrossLinksGrid-module-scss-module__9seLzq__collapsible",
  "content": "CoreCrossLinksGrid-module-scss-module__9seLzq__content",
  "cta": "CoreCrossLinksGrid-module-scss-module__9seLzq__cta",
  "heading": "CoreCrossLinksGrid-module-scss-module__9seLzq__heading",
  "icon": "CoreCrossLinksGrid-module-scss-module__9seLzq__icon",
  "icon--new-tab": "CoreCrossLinksGrid-module-scss-module__9seLzq__icon--new-tab",
  "link": "CoreCrossLinksGrid-module-scss-module__9seLzq__link",
  "list": "CoreCrossLinksGrid-module-scss-module__9seLzq__list",
  "list-item": "CoreCrossLinksGrid-module-scss-module__9seLzq__list-item",
  "main": "CoreCrossLinksGrid-module-scss-module__9seLzq__main",
  "pdf": "CoreCrossLinksGrid-module-scss-module__9seLzq__pdf",
  "slide-down": "CoreCrossLinksGrid-module-scss-module__9seLzq__slide-down",
  "slide-up": "CoreCrossLinksGrid-module-scss-module__9seLzq__slide-up",
  "top-list": "CoreCrossLinksGrid-module-scss-module__9seLzq__top-list",
});
